export const STORAGE_ITEM_NAME = 'rp-userPreference';
export const UPDATE_TARGETING = 'updateTargeting';

export const HIDE_OFFER_CLASS = 'hideOfferComponent';
export const BETTING_SPECIAL_OFFER_CLASS = '.rp-resultsBettingsOffer';




// WEBPACK FOOTER //
// ./src/js/config/storage.js